export const environment = {
  production: true,
  postService: "https://jsonplaceholder.typicode.com/posts",
  userService: "https://jsonplaceholder.typicode.com/users",
};
